export const MOBILE_BREAKPOINT = 700;
